export const MID_START_BASELINE = 750;
